import React from 'react'
import { format } from 'date-fns'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { formatPhone, formatDollars } from '../common/AssignmentUtils'

const PropertyInfoSection = ({ assignmentDetails }) =>
  <LgySubsection header='Property Information' className='assignment-details-child property-information'>
    <span>
      <span className='caption'>Title Limitations and Restrictive Convenants:</span>
      <br />
      {assignmentDetails.titleLimit}
    </span>

    <hr />

    <div className='usa-width-one-whole'>
      <div className='usa-width-one-half'>
        <table>
          <caption>Lot Dimensions</caption>
          <tbody>
            <tr>
              <th scope='row'>Width:</th>
              <td>{assignmentDetails.lotWidth}</td>
            </tr>
            <tr>
              <th scope='row'>Length:</th>
              <td>{assignmentDetails.lotLength}</td>
            </tr>
            <tr>
              <th scope='row'>Total square feet:</th>
              <td>{assignmentDetails.lotWidth * assignmentDetails.lotLength}</td>
            </tr>
            <tr>
              <th scope='row'>Irregular square feet:</th>
              <td>{assignmentDetails.lotIrregularFeet}</td>
            </tr>
            <tr>
              <th scope='row'>Acres:</th>
              <td>{assignmentDetails.lotAcres}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='usa-width-one-half'>
        <table>
          <caption>Source of Utilites</caption>
          <tbody>
            <tr>
              <th scope='row'>Electric:</th>
              <td>{assignmentDetails.electricUtility}</td>
            </tr>
            <tr>
              <th scope='row'>Gas:</th>
              <td>{assignmentDetails.gasUtility}</td>
            </tr>
            <tr>
              <th scope='row'>Water:</th>
              <td>{assignmentDetails.waterUtility}</td>
            </tr>
            <tr>
              <th scope='row'>Sewer:</th>
              <td>{assignmentDetails.sewerUtility}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr />

    <div className='usa-width-one-whole'>
      <div className='usa-width-one-half'>
        <span className='caption'>Equipment</span>
        <ul>
          {assignmentDetails.washerEquipment === 'YES' && <li>Clothes Washer</li>}
          {assignmentDetails.dryerEquipment === 'YES' && <li>Clothes Dryer</li>}
          {assignmentDetails.dishwasherEquipment === 'YES' && <li>Dishwasher</li>}
          {assignmentDetails.ovenEquipment === 'YES' && <li>Range/Oven</li>}
          {assignmentDetails.ventfanEquipment === 'YES' && <li>Vent Fan</li>}
          {assignmentDetails.fridgeEquipment === 'YES' && <li>Refrigerator</li>}
          {assignmentDetails.garbageEquipment === 'YES' && <li>Garbage Disposal</li>}
          {assignmentDetails.wwcarpetEquipment === 'YES' && <li>WW Carpet</li>}
        </ul>
      </div>
      <div className='usa-width-one-half'>
        <table>
          <caption>Warranty Information</caption>
          <tbody>
            <tr>
              <th scope='row'>Construction warranty included:</th>
              <td>{assignmentDetails.constructionWarranty}</td>
            </tr>
            <tr>
              <th scope='row'>Construction completion date:</th>
              <td>{assignmentDetails.constructionCompletionDate ? format(assignmentDetails.constructionCompletionDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : ''}</td>
            </tr>
            <tr>
              <th scope='row'>Name of warranty program:</th>
              <td>{assignmentDetails.warrantyName}</td>
            </tr>
            <tr>
              <th scope='row'>Warranty expiration date:</th>
              <td>{assignmentDetails.warrantyExpirationDate ? format(assignmentDetails.warrantyExpirationDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : ''}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr />

    <div className='usa-width-one-whole'>
      <div className='usa-width-one-half'>
        <table>
          <caption>Building Details</caption>
          <tbody>
            <tr>
              <th scope='row'>Building status:</th>
              <td>{assignmentDetails.proposedExistingCode}</td>
            </tr>
            <tr>
              <th scope='row'>Building type:</th>
              <td>{assignmentDetails.buildingType}</td>
            </tr>
            <tr>
              <th scope='row'>Factory fabricated:</th>
              <td>{assignmentDetails.factoryFabricatedCode === '1' ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <th scope='row'>Number of buildings:</th>
              <td>{assignmentDetails.buildingCount}</td>
            </tr>
            <tr>
              <th scope='row'>Street access:</th>
              <td>{assignmentDetails.streetAccess}</td>
            </tr>
            <tr>
              <th scope='row'>Number of living units:</th>
              <td>{assignmentDetails.livingUnitQuantity}</td>
            </tr>
            <tr>
              <th scope='row'>Street maintenance:</th>
              <td>{assignmentDetails.streetMaintenance}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='usa-width-one-half'>
        <table>
          <caption>Occupancy Information</caption>
          <tbody>
            <tr>
              <th scope='row'>Property occupancy:</th>
              <td>{assignmentDetails.propertyStatus}</td>
            </tr>
            <tr>
              <th scope='row'>Monthly rent:</th>
              <td>${formatDollars(assignmentDetails.monthlyRentAmount)}</td>
            </tr>
            <tr>
              <th scope='row'>Occupant name:</th>
              <td>{assignmentDetails.occupantName}</td>
            </tr>
            <tr>
              <th scope='row'>Occupant phone number:</th>
              <td>{formatPhone(assignmentDetails.occupantPhoneNumber)}</td>
            </tr>
            <tr>
              <th scope='row'>Broker name:</th>
              <td>{assignmentDetails.brokerName}</td>
            </tr>
            <tr>
              <th scope='row'>Broker phone number:</th>
              <td>{formatPhone(assignmentDetails.brokerPhoneNumber)}</td>
            </tr>
            <tr>
              <th scope='row'>Address where keys are located (if vacant):</th>
              <td>{assignmentDetails.keysAt}<br />{formatPhone(assignmentDetails.keysAtPhoneNumber)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </LgySubsection>

export default PropertyInfoSection
